import { render, staticRenderFns } from "./JobBlock.vue?vue&type=template&id=7be1fe96&scoped=true&"
import script from "./JobBlock.vue?vue&type=script&lang=js&"
export * from "./JobBlock.vue?vue&type=script&lang=js&"
import style0 from "./JobBlock.vue?vue&type=style&index=0&id=7be1fe96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be1fe96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VCol,VRow})
